export const CONTAINERMASTER_DATA_COLUMNS = [
  {
    Header: "UPDATE",
    accessor: "add_Data",
    width : 1
  },
  {
    Header: "OFP PLAN DATE",
    accessor: "Date",
    width : 1
  },
  {
    Header: "MODULE",
    accessor: "DataOf",
    width : 1
  },
  {
    Header: "ON HOLD CONTAINER",
    accessor: "isOnHold",
    width : 1
  },
  {
    Header: "FACTORY IN DATE",
    accessor: "Gate_In_Date",
    Cell:(data) =>{
      const {row} = data;
     
      return <p style={{marginBottom:"0px"}}>{row?.original?.Gate_In_Date} {row?.original?.Gate_In_Time ?new Date(`2000-01-01T${row?.original?.Gate_In_Time}`).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) : null}</p>
    },
    width : 1
  },
 
  {
    Header: "FACTORY OUT DATE",
    accessor: "Gate_Out_Date",
    Cell:(data) =>{
      const {row} = data;
     
      return <p style={{marginBottom:"0px"}}>{row?.original?.Gate_Out_Date} {row?.original?.Gate_Out_Time ? new Date(`2000-01-01T${row?.original?.Gate_Out_Time}`).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) : null}</p>
    },
    width : 1
    
  },

  {
    Header: "INVOICE",
    accessor: "invoice",
  },
  {
    Header: "TRACTOR QTY",
    accessor: "T_qty",
  },
  {
    Header: "AGG. QTY",
    accessor: "A_qty",
    width : 1
  },
  {
    Header: "AGG. PART",
    accessor: "A_Part",
    width : 1
  },
  {
    Header: "RFID SEAL NO",
    accessor: "RFID_Seal_No",
    width : 1
  },
  {
    Header: "CONTAINER NO",
    accessor: "Container_Number",
    width : 1
  },
  {
    Header: "SEAL NO",
    accessor: "Seal_No",
  },
  {
    Header: "LR NO",
    accessor: "LR_NO",
    width : 1
  },
  {
    Header: "VEHICLE NO",
    accessor: "Vehicle_No",
    width : 1
  },
  {
    Header: "CARRIER",
    accessor: "Carrier",
    width : 1
  },
  {
    Header: "CLEARANCE",
    accessor: "Clearence",
    width : 1
  },
  {
    Header: "DEST COUNTRY",
    accessor: "Dest_Country",
    width : 1
  },
  {
    Header: "DEST PORT",
    accessor: "Dest_Port",
    width : 1
  },
  {
    Header: "FINAL DEST",
    accessor: "final_destination_ConMaster",
    width : 1
  },
  {
    Header: "PRODUCT",
    accessor: "Product",
    width : 1
  },
  {
    Header: "BOOKING NO",
    accessor: "Booking_Number",
    width : 1
  },
  {
    Header: "TRANSPORTER",
    accessor: "Transporter",
    width : 1
  },
  {
    Header: "PICK UP LOCATION",
    accessor: "pick_up_location",
    width : 1
  },
  {
    Header: "SAP CODE",
    accessor: "SAP_code",
    width : 1
  },
  {
    Header: "CONTAINER TYPE",
    accessor: "Container_Type",
    width : 1
  },
  {
    Header: "DRIVER NO",
    accessor: "Driver_No",
    width : 1
  },
  {
    Header: "LINER",
    accessor: "Liner",
    width : 1
  },
  {
    Header: "REMARK",
    accessor: "Remarks",
    width : 1
  },
  {
    Header: "UPLOAD DOC",
    accessor: "upload_doc",
    width : 1
  },
  {
    Header: "VIEW DOC",
    accessor: "view_doc",
    width : 1
  },
  {
    Header: "BACK TO TOWN",
    accessor: "Back_To_Town",
    width : 1
  },
  {
    Header: "CARGO CREATION",
    accessor: "isCargoCreated",
    width : 1
  },
  
];

export const CONTAINERMASTER_DATA_EMAIL_COLUMNS = [
  {
    Header: "EMAIL STATUS",
    accessor: "email_status",
    width : 1
  },
  {
    Header: "OFP PLAN DATE",
    accessor: "Date",
    width : 1
  },
  {
    Header: "MODULE",
    accessor: "DataOf",
    width : 1
  },
  {
    Header: "FACTORY IN DATE",
    accessor: "Gate_In_Date",
    width : 1
  },
  {
    Header: "FACTORY OUT DATE",
    accessor: "Gate_Out_Date",
    width : 1
  },
  {
    Header: "INVOICE",
    accessor: "invoice",
  },
  {
    Header: "TRACTOR QTY",
    accessor: "T_qty",
  },
  {
    Header: "AGG. QTY",
    accessor: "A_qty",
    width : 1
  },
  {
    Header: "AGG. PART",
    accessor: "A_Part",
    width : 1
  },
  {
    Header: "RFID SEAL NO.",
    accessor: "RFID_Seal_No",
    width : 1
  },
  {
    Header: "CONTAINER NO",
    accessor: "Container_Number",
    width : 1
  },
  {
    Header: "SEAL NO",
    accessor: "Seal_No",
  },
  {
    Header: "LR NO",
    accessor: "LR_NO",
    width : 1
  },
  {
    Header: "VEHICLE NO",
    accessor: "Vehicle_No",
    width : 1
  },
  {
    Header: "CARRIER",
    accessor: "Carrier",
    width : 1
  },
  {
    Header: "CLEARANCE",
    accessor: "Clearence",
    width : 1
  },
  {
    Header: "DEST COUNTRY",
    accessor: "Dest_Country",
    width : 1
  },
  {
    Header: "DEST PORT",
    accessor: "Dest_Port",
    width : 1
  },
  {
    Header: "FINAL DEST",
    accessor: "final_destination_ConMaster",
    width : 1
  },
  {
    Header: "PRODUCT",
    accessor: "Product",
    width : 1
  },
  {
    Header: "BOOKING NO",
    accessor: "Booking_Number",
    width : 1
  },
  {
    Header: "TRANSPORTER",
    accessor: "Transporter",
    width : 1
  },
  {
    Header: "PICK UP LOCATION",
    accessor: "pick_up_location",
    width : 1
  },
  {
    Header: "SAP CODE",
    accessor: "SAP_code",
    width : 1
  },
  {
    Header: "CONTAINER TYPE",
    accessor: "Container_Type",
    width : 1
  },
  {
    Header: "DRIVER NO",
    accessor: "Driver_No",
    width : 1
  },
  {
    Header: "REMARK",
    accessor: "Remarks",
    width : 1
  }
];